import { render, staticRenderFns } from "./v-gltfmod.vue?vue&type=template&id=0b906f35&scoped=true"
import script from "./v-gltfmod.vue?vue&type=script&lang=js"
export * from "./v-gltfmod.vue?vue&type=script&lang=js"
import style0 from "./v-gltfmod.vue?vue&type=style&index=0&id=0b906f35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b906f35",
  null
  
)

export default component.exports